// Mock data for RUSH Frozen Yogurt website

export const locations = [
  {
    id: 1,
    country: "Nigeria",
    city: "Lagos",
    address: "123 Victoria Island, Lagos",
    phone: "+234 801 234 5678",
    hours: "Mon-Sun: 10AM - 10PM",
    flag: "🇳🇬"
  },
  {
    id: 2,
    country: "Ghana",
    city: "Accra",
    address: "45 Oxford Street, Osu, Accra",
    phone: "+233 24 123 4567",
    hours: "Mon-Sun: 10AM - 10PM",
    flag: "🇬🇭"
  },
  {
    id: 3,
    country: "Lithuania",
    city: "Vilnius",
    address: "78 Gedimino Avenue, Vilnius",
    phone: "+370 5 123 4567",
    hours: "Mon-Sun: 11AM - 9PM",
    flag: "🇱🇹"
  }
];

export const aboutContent = {
  title: "Chill Out with Rush",
  description: "RUSH Frozen Yogurt brings you the freshest, most delicious frozen yogurt experience across Africa and Europe. Our signature creamy yogurt paired with premium fruit toppings creates moments of pure joy.",
  highlights: [
    "Premium quality frozen yogurt",
    "Fresh fruit toppings daily",
    "Unique flavor combinations",
    "International presence"
  ]
};

export const socialLinks = {
  instagram: "https://instagram.com/rushfroyo",
  facebook: "https://facebook.com/rushfroyo",
  twitter: "https://twitter.com/rushfroyo",
  handle: "@rushfroyo"
};

export const heroContent = {
  tagline: "CHILL OUT WITH",
  brand: "RUSH",
  subtitle: "Premium Frozen Yogurt",
  cta: "Find a Location"
};
